import * as go from 'gojs';
import theme from 'theme/theme';

const $ = go.GraphObject.make;

/**
 * Template for when a unit is selected
 */

export const SelectionAdornment = $(
  go.Adornment,
  'Auto',
  $(go.Shape, 'RoundedRectangle', {
    width: 32,
    height: 32,
    strokeWidth: 1,
    parameter1: 8,
    stroke: '#327DFF',
    fill: theme.palette.info.light,
  }),
  { layerName: 'Background' },
  $(go.Placeholder),
);

export const HoverAdornment = $(
  go.Adornment,
  'Auto',
  $(go.Shape, 'RoundedRectangle', {
    width: 32,
    height: 32,
    strokeWidth: 0,
    parameter1: 8,
    stroke: null,
    fill: theme.palette.info.light,
  }),
  { layerName: 'Background' },
  $(go.Placeholder),
);
